import { render, staticRenderFns } from "./industryNews.vue?vue&type=template&id=f87b420e&scoped=true"
import script from "./industryNews.vue?vue&type=script&lang=js"
export * from "./industryNews.vue?vue&type=script&lang=js"
import style0 from "./industryNews.vue?vue&type=style&index=0&id=f87b420e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87b420e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f87b420e')) {
      api.createRecord('f87b420e', component.options)
    } else {
      api.reload('f87b420e', component.options)
    }
    module.hot.accept("./industryNews.vue?vue&type=template&id=f87b420e&scoped=true", function () {
      api.rerender('f87b420e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/page/industryNews.vue"
export default component.exports